<script lang="ts">
  import {parse} from 'query-string';
  import {loadGoogleAccountScript} from '@/resource/js';
  import {createEventDispatcher, getContext, onMount} from 'svelte';
  import {sd} from '@/da';
  import {mc} from '@/core';
  import {LANG_MAP} from '@/map';
  import {doCaptcha} from '@/captcha';
  import {userApi} from '@/api/user';
  import {drawerUtil} from '@/helper/drawer';
  import {checkTarget, navAfterRegisterSuccess} from '@/helper/login';
  import {PATHS} from '@/const/paths';
  import Spin from '@/widgets/Spin.svelte';
  import {fixLink$, lang$} from '@/store/lang';
  import {clientId} from './const';
  import '../access-google/access-styled.scss';

  let className = '';
  export {className as class};
  export let loginType: string = '';
  export let scene;
  export let referralCode = '';
  export let group: string | number = '';
  export let isOauth;
  export let width = 48;
  export let lang = {};
  export let iconInfo = {
    defaultIcon: 'https://img.phemex.com/v1/0e256287-a019-4a9a-a9e6-a892e8c94e0a/login-google.png',
    hoverIcon: 'https://img.phemex.com/v1/97814ddd-fb2d-48fe-982a-02e9bcbecb9f/login-google-hover.png',
    alt: 'icon',
    visibleTitle: false,
  }

  const dispatch = createEventDispatcher();
  const LG = getContext('LG');
  let search = '';
  let ready = false;
  let loading = false;
  let disabled = false;
  let target;

  onMount(async () => {
    await loadGoogleAccountScript().then(()=> {
      ready = true;
    });
    const query = parse(window.location.search);
    search = window.location.search;
    target = isOauth ? location.origin + $fixLink$(PATHS.OAUTH_AUTHORIZE.pathname) + search + '&status=logged' : query.target;
    if (!window.google) {
      return;
    }
    google.accounts.id.initialize({
      client_id: clientId,
      callback: handleCredentialResponse,
    });
    google.accounts.id.renderButton(document.getElementById('buttonDiv'), {theme: 'outline', size: 'large', width});
    google.accounts.id.prompt();
    const iframe = document.getElementById('buttonDiv').querySelector('iframe');
    if(iframe) {
      iframe.style = 'position:absolute;top:0;width:inherit; height:inherit;'
    }
  });

  async function handleCredentialResponse(response) {
    loading = true;
    const captchaResult = await doCaptcha('register');
    if (!captchaResult) {
      mc.send('toast', 'error', {message: LG(lang.NetworkError)});
      loading = false;
      return;
    }

    const params = {
      group,
      authToken: response.credential,
      authSource: 'google',
      referralCode,
      nickName: '',
      lang: LANG_MAP[$lang$] || $lang$,
      userDeviceLang: (navigator.language || navigator.userLanguage).substring(0, 2),
    };
    const {data, error} = await userApi.authLogin(captchaResult, params);
    if (data) {
      if (data.decision === 1 || data.decision === 3) {
        await confirmAuthLogin(data);
      }
      if (data.decision === 2) {
        if(loginType === 'drawer-login') {
          setTimeout(()=> {
            dispatch('close');
          },0)
        }
        drawerUtil.launchBindGoogleVerificationPage(LG, data, {isOauth, search});
      }
    }
    if (error) {
      mc.send('toast', 'error', error);
    }
    loading = false;
    disabled = false;
  }

  async function confirmAuthLogin(content) {
    const params = {email: content.email, code: content.code};
    const {data, error} = await userApi.confirmAuthLogin(params);
    if (data) {
      if (isOauth) {
        window.location.assign($fixLink$(PATHS.OAUTH_AUTHORIZE.pathname) + search + '&status=logged');
        return;
      }
      if (content.decision === 1) {
        navAfterRegisterSuccess(checkTarget(target) && target);
        return;
      }
      if (content.decision === 3) {
        navAfterRegisterSuccess(checkTarget(target) && target);
        return;
      }
    }
    if (error) {
      mc.send('toast', 'error', error);
    }
  }


  function handleClick(event){
    event.stopPropagation();
    loading = true;
    sd.track('web_click', {$screen_name: 'register', $element_content: 'sign_up_with_google'});
    sd.track('web_view', {$screen_name: 'register', $element_content: 'sign_up_with_google'});
  }
</script>

<style lang="scss">
  .button-overlay {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: 0;
    box-sizing: border-box;
    min-width: 0;
    opacity: 0.0001;
  }
  .button-overlay> div{
    width: 56px;
    height: 56px;
    padding: 0;
  }
  .button-overlay > div :global(div){
    width: inherit;
    height: inherit;
    padding: 0;
    z-index: 1;
  }
  .button-overlay > div :global(span){
    display: none;
  }
  .button-overlay div[role="button"]{
    position: relative;
  }
  .button-overlay :global(div[role="button"] > div:nth-child(2)){
    width: inherit;
    height: inherit;
    position: absolute;
    padding: 0;
    top: 0;
  }
</style>

<section class="wallet-connect-box">
  <div class="pr f16 df cp {className}" style="padding: 0" on:click|stopPropagation={handleClick}>
    {#if !!ready && !loading}
    <div class="df fdc jcc aic">
      <div class="img df jcc aic pr">
          <img width={width} height={width} data-replace-icon="false" src={iconInfo.defaultIcon} alt={iconInfo.alt} />
          <img width={width} height={width} class="white" data-replace-icon="false" src={iconInfo.hoverIcon} alt={iconInfo.alt} />
      </div>
      {#if iconInfo.visibleTitle}
        <div class="con mt12 f12 lh18 T3 sm:hidden">Google</div>
      {/if}
    </div>
    {#if !loading}<div class="button-overlay cp"><div id="buttonDiv" /></div>{/if}
    {:else}
      <Spin style="background: none;transform: scale(0.7);" />
    {/if}
  </div>
</section>
